"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _LinkItem = _interopRequireDefault(require("./LinkItem"));
var _ = require("../");
var _auth = require("../../modules/auth");
var _Spinner = _interopRequireDefault(require("../../components/Spinner"));
var _package = _interopRequireDefault(require("../../../../../package.json"));
var _icon = _interopRequireDefault(require("./../../../fonts/icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class Level1 extends _react.default.Component {
  componentDidMount() {
    const scrollContainer = document.querySelector(".scroll-container");
    scrollContainer.addEventListener("scroll", () => {
      if (scrollContainer.scrollTop > 1) {
        scrollContainer.classList.add("scroll-container-border");
      } else {
        scrollContainer.classList.remove("scroll-container-border");
      }
    });
  }
  render() {
    const logo_small = `/logo_small.svg`;
    const logo_big = `/logo_big.svg`;
    const {
      me,
      authenticated,
      loggedOut,
      links,
      expanded,
      onLinkActive,
      history,
      onToggle,
      maintenance
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("nav", {
      className: "menu-first " + (expanded ? "expanded" : "")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-first-inner " + (expanded ? "expanded" : "")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row justify-content-center align-items-center menu-logo-wrapper",
      onClick: () => onToggle(!expanded)
    }, expanded ? /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-logo-big"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: logo_big
    })) : /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-logo-small"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: logo_small
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "scroll-container " + (expanded ? "" : "scroll-container-notExpanded")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "position-relative"
    }, authenticated && /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
      activeClassName: "active",
      className: "menu-link-wrapper d-flex align-items-center user-wrapper",
      to: "/account"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex justify-content-center align-items-center picture-wrapper"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "align-self-center picture",
      id: "Profile"
    }, me && me.UserImage && me.UserImage.Data ? /*#__PURE__*/_react.default.createElement(_.Picture, {
      value: me.UserImage.Data,
      format: "base64"
    }) : /*#__PURE__*/_react.default.createElement("span", {
      className: "avatar-round avatar-user"
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "justify-content-center"
    }, me && `${me.GivenName} ${me.FamilyName}`))), /*#__PURE__*/_react.default.createElement("div", null, authenticated && links.map((link, index) => {
      return /*#__PURE__*/_react.default.createElement(_LinkItem.default, {
        exact: false,
        link: link,
        expanded: expanded,
        className: "",
        onLinkActive: onLinkActive,
        key: index
      });
    })), me || loggedOut || maintenance ? null : /*#__PURE__*/_react.default.createElement(_Spinner.default, null), authenticated || maintenance ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(SignOutButton, {
      history: history,
      expanded: expanded
    })) : null, expanded && /*#__PURE__*/_react.default.createElement(BaseVersion, null), /*#__PURE__*/_react.default.createElement("div", {
      className: "clickable-area",
      onClick: () => onToggle(!expanded)
    })), " "));
  }
}
const SignOutButton = props => {
  const {
    expanded
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "menu-link-wrapper position-relative sign-out-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_auth.SignOut, {
    history: props.history
  }, props => /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-content-center justify-content-center sign-out-button",
    onClick: props.onSubmit
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "material-icons align-self-center d-flex",
    id: "SignOut"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    icon: "VDC_IconFont_LogOut",
    size: 24
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "align-self-center sign-out-text",
    onClick: props.onSubmit
  }, "Sign Out"))));
};
const BaseVersion = () => {
  let versionAndStage = "";
  versionAndStage = _package.default.version;
  switch (process.env.REACT_APP_STAGE) {
    case "dev":
    case "test":
    case "prod":
      versionAndStage += " " + process.env.REACT_APP_STAGE.charAt(0).toUpperCase();
      break;
    default:
      versionAndStage += " " + (process.env.REACT_APP_STAGE || "");
      break;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "base-version"
  }, /*#__PURE__*/_react.default.createElement("p", null, versionAndStage));
};
var _default = exports.default = Level1;
module.exports = exports.default;